<template>
    <div>
        <LineChartGenerator
            :chart-options="chartOptions"
            :chart-data="chartData"
            :chart-id="chartId"
            :dataset-id-key="datasetIdKey"
            :plugins="plugins"
            :css-classes="cssClasses"
            :styles="styles"
            :width="width"
            :height="height"
        />
        <div
            v-if="!chartData && !loading"
            class="d-flex fill-height pa-4 justify-center align-center grey lighten-4"
            :style="{ 'min-height': `${height}px` }"
        >
            <div>No Data</div>
        </div>
        <div
            v-if="loading"
            class="d-flex fill-height pa-4 justify-center align-center grey lighten-4"
            :style="{ 'min-height': `${height}px` }"
        >
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </div>
    </div>
</template>
<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
// import * as annotation from 'chartjs-plugin-annotation';
// import annotationPlugin from 'chartjs-plugin-annotation';
// import AnnotationPlugin from "chartjs-plugin-annotation";
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    Filler,
} from "chart.js";
import { roundUp } from "../utility/roundUp";

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    Filler
    // AnnotationPlugin
);
export default {
    name: "LineChartLatest",

    components: {
        LineChartGenerator,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        labels: {
            type: Array,
        },
        xTitle: {
            type: String,
        },
        yTitle: {
            type: String,
        },
        peak: {
            type: Number,
        },
        turf: {
            type: Number,
        },

        datasets: {
            type: Array,
        },

        options: {
            type: Object,
        },
        chartId: {
            type: String,
            default: "line-chart",
        },
        annotationId: {
            type: String,
            default: "annotaion-id",
        },
        datasetIdKey: {
            type: String,
            default: "label",
        },
        width: {
            type: Number,
            default: 400,
        },
        height: {
            type: Number,
            default: 400,
        },
        cssClasses: {
            default: "",
            type: String,
        },
        styles: {
            type: Object,
            default: () => {},
        },
        plugins: {
            type: Array,
            default: () => [],
        },
    },
    data() {
         this.datasets[0].data.forEach((item, i) => {this.datasets[0].data[i]=roundUp(this.datasets[0].data[i],2);});
         this.datasets[1].data.forEach((item, i) => {this.datasets[1].data[i]=roundUp(this.datasets[1].data[i],2);});
         this.datasets[2].data.forEach((item, i) => {this.datasets[2].data[i]=roundUp(this.datasets[2].data[i],2);});
         this.datasets[3].data.forEach((item, i) => {this.datasets[3].data[i]=roundUp(this.datasets[3].data[i],2);});
         //console.log("line dataset",this.datasets[0].data)
        return {};
    },
    computed: {
        chartData() {
            return {
                labels: this.labels,
                datasets: this.datasets,
            };
        },

        chartOptions() {
            return {
                plugins: {
                    autocolors: false,
                    // annotation: {
                    //   annotations: {
                    //     peak: {
                    //       id: "peak_" + this.annotationId,
                    //       scaleID: "y-axis-0" ,
                    //       type: "line",
                    //       yMin: this.peak,
                    //       yMax: this.peak,
                    //      borderColor: "green",
                    //     },
                    //     turf: {
                    //       id: "turf_" + this.annotationId,
                    //       scaleID: "y-axis-0" ,
                    //       type: "line",
                    //       yMin: this.turf,
                    //       yMax: this.turf,
                    //       borderColor: "red",
                    //     },
                    //   },
                    // },
                },
                scales: {
                    y: {
                        title: {
                            display: true,
                            text: this.yTitle,
                        },
                    },
                    x: {
                        title: {
                            display: true,
                            text: this.xTitle,
                        },
                    },
                },
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 20,
                        right: 20,
                        top: 30,
                        bottom: 10,
                    },
                },
            };
        },
    },
};
</script>
